import { Feature, MultiPolygon } from 'geojson';
import { Source, Layer } from 'react-map-gl';

interface PlotOutlineLayerProps {
  data?: Feature<MultiPolygon, unknown>;
  lineColor?: string;
  lineWidth?: number;
}

export function PlotOutlineLayer(props: PlotOutlineLayerProps) {
  const { data, lineColor = '#000', lineWidth = 3 } = props;
  if (!data) return null;
  return (
    <Source data={data} id="plot-outline" type="geojson">
      <Layer
        id="plot-outline"
        paint={{
          'line-color': lineColor,
          'line-width': lineWidth,
        }}
        type="line"
      />
    </Source>
  );
}

export default PlotOutlineLayer;
